const enums = {
  MUX_STATUS_READY:   'ready',
  MUX_STATUS_PENDING: 'pending',
  MUX_STATUS_FAILED:  'failed',

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Fraud strategy. WYN-6590. Now the fraud strategy is defined for the whole campaign*/

  // No fraud prevention.
  STRATEGY_FRAUD_NONE:       'strategy.fraud.none',
  // Always present Captcha overlay.
  STRATEGY_FRAUD_CAPTCHA:    'strategy.fraud.recaptcha',
  // Dynamically present Captcha overlay when backend asks for it.
  STRATEGY_FRAUD_DYNCAPTCHA: 'strategy.fraud.dynamiccaptcha',
  // Cloudflare Turnstile Captcha
  STRATEGY_FRAUD_TURNSTILE:  'strategy.fraud.turnstile',

  /* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - */
  /* Privacy service & cookie consent interface. WYN-6333.
   */
  // The different classes of cookies we support.  These will be used by the rest of display when querying if we
  // have permission to use cookies for a particular functionality.
  PRIVACY_TYPES: {
    NECESSARY:  'strictly necessary',
    FUNCTIONAL: 'functional',
    MARKETING:  'marketing',
    ANALYTICS:  'analytics',
  },

  // This setting is controlled on the publishing page for each display container. The customer may choose whether to:
  // - use our Experiences platform privacy management tool with UI (all parts are enabled)
  // - use the API and their own UI tool to control privacy (api and code gating are still enabled, no UI)
  // - fully disable all privacy management (the ui, api and code gating)
  //
  // If the customer chooses 'custom', then the UI is disabled and the privacy service defaults to consent granted for
  // only strictly necessary cookies.
  PRIVACY_MANAGEMENT_ENABLED: {
    EXPERIENCES: 'strategy.privacymgmt.experiences', // Use the experiences platform privacy management tool.
    CUSTOM:      'strategy.privacymgmt.custom', // Use their own privacy mangement tool and set privacy via the API.
    NONE:        'strategy.privacymgmt.none', // This experience will have no privacy management, no UI, no code gating.
  },

  // Some of the error codes which could happen when submitting the form
  SUBMIT_RESPONSE_ERROR_CODES: {
    PROMOTION_CLOSED: 'exception.display.promotion.closed',
    CAPTCHA_REQUIRED: 'exception.captcha.required',
  },

  // The possible captcha libraries. They contain sdk name (see coreapp/src/main/javascript/display/legacy/providers/sdks.js)
  // and the name of  the "window" property which can be used in client side (e.g. window.grecaptcha.render)
  CAPTCHA_LIBS: {
    recaptcha: {
      sdk:         'recaptcha',
      libName:     'grecaptcha',
      resetMethod: 'reset',
    },
    turnstile: {
      sdk:         'turnstile',
      libName:     'turnstile',
      resetMethod: 'remove',
    },
  },
};
export default enums;
